import Modal from '../ui/Modal';
import FieldAnswerList from '../fields/FieldAnswerList';

const TYPE_LABEL = {
  attempt: 'Attempt',
  linked_reset: 'Reset by attempt limit',
};

/** Read-only list of a step's archived attempts, newest first. */
export default function AttemptHistoryModal({ open, onClose, step }) {
  const entries = [...(step.attempt_history || [])].reverse();

  return (
    <Modal open={open} onClose={onClose} title={`${step.title} — history`} size="xl">
      {entries.length === 0 ? (
        <p className="text-sm text-gray-500">No history yet.</p>
      ) : (
        <div className="space-y-4">
          {entries.map((e, i) => {
            const failed = e.type === 'attempt';
            return (
              <div key={`${e.at}-${i}`} className="rounded-md border border-gray-200 p-3">
                <div className="mb-2 flex flex-wrap items-center gap-2 text-sm">
                  <span className="font-semibold text-gray-800">
                    {failed ? `Attempt ${e.attempt} of ${e.max}` : TYPE_LABEL[e.type] || e.type}
                  </span>
                  {failed && (
                    <span className={`rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase ${e.outcome === 'max_reached' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-800'}`}>
                      {e.outcome === 'max_reached' ? 'Limit reached' : 'Failed'}
                    </span>
                  )}
                  <span className="text-xs text-gray-400">
                    {e.by ? `${e.by} · ` : ''}
                    {e.at ? new Date(e.at).toLocaleString() : ''}
                  </span>
                </div>
                {e.reason && <p className="mb-2 text-xs text-gray-500">{e.reason}</p>}
                {e.remarks && <p className="mb-2 text-sm text-gray-700">Remarks: {e.remarks}</p>}
                {(step.fields || []).length > 0 && Object.keys(e.answers || {}).length > 0 ? (
                  // Own <form> per entry: radio groups share a name (the field id) and the browser treats
                  // same-named radios on one page as one group, which left only one entry showing its answer.
                  <form onSubmit={(ev) => ev.preventDefault()} className="pointer-events-none opacity-80">
                    <FieldAnswerList
                      fields={step.fields}
                      answers={e.answers || {}}
                      onAnswer={() => {}}
                      className="grid grid-cols-1 gap-x-4 gap-y-3 md:grid-cols-2"
                    />
                  </form>
                ) : (
                  <p className="text-xs text-gray-400">No field data recorded.</p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
}
